<mat-form-field *ngIf="type == 'year'"  [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matDatepicker]="db" [formControl]="date" autocomplete="off" />
  <mat-hint *ngIf="matHint">YYYY</mat-hint>
  <mat-datepicker-toggle matSuffix [for]="db"></mat-datepicker-toggle>
    <mat-datepicker #db
      startView="multi-year"
      (yearSelected)="chosenDateHandlerYear($event, db)"
      panelClass="example-month-picker">
    </mat-datepicker>
</mat-form-field>

<mat-form-field *ngIf="type == 'month'" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matDatepicker]="db" [formControl]="date" autocomplete="off" />
  <mat-hint *ngIf="matHint">MM/YYYY</mat-hint>
  <mat-datepicker-toggle matSuffix  [for]="db"></mat-datepicker-toggle>
    <mat-datepicker #db
      startView="multi-year"
      (monthSelected)="chosenDateHandlerMonth($event, db)"
      panelClass="example-month-picker">
    </mat-datepicker>
</mat-form-field>


<mat-form-field *ngIf="type == '' || type =='date'" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matDatepicker]="db" [formControl]="fullDate" autocomplete="off"  (dateChange)="chosenDateHandlerDate()"/>
  <mat-hint *ngIf="matHint">MM/DD/YYYY</mat-hint>
  <mat-datepicker-toggle matSuffix [for]="db"></mat-datepicker-toggle>
  <mat-datepicker #db [touchUi]="movil ? true : false"></mat-datepicker>
</mat-form-field>

